import { useRecoilState } from 'recoil'
import {
  deviceDataState,
  stripeRadarSessionState,
} from '../../common/atoms/checkout'
import { useEffect } from 'react'
import { SessionStatusEnum } from '../../common/enums/session-status.enum'
import { useSession } from 'next-auth/react'
import { clientTokenState } from '../../common/atoms/atoms'
import { useGetBrainTreeToken } from './useGetBrainTreeToken'
import { loadStripe } from '@stripe/stripe-js/pure'
import dataCollector from 'braintree-web/data-collector'
import client from 'braintree-web/client'

export function useDeviceData() {
  const [deviceData, setDeviceData] = useRecoilState(deviceDataState)
  const [, setStripeRadarSession] = useRecoilState(stripeRadarSessionState)

  const { status } = useSession()
  const [clientToken, setClientToken] = useRecoilState(clientTokenState)
  const { data: brainTreeToken, mutate } = useGetBrainTreeToken()

  useEffect(() => {
    if (status === SessionStatusEnum.AUTHENTICATED && !clientToken) {
      mutate()
    } else if (status === SessionStatusEnum.UNAUTHENTICATED && clientToken) {
      setClientToken('')
    }
  }, [status])

  useEffect(() => {
    if (brainTreeToken) {
      setClientToken(brainTreeToken.clientToken)
    }
  }, [brainTreeToken])

  useEffect(() => {
    if (clientToken && clientToken !== '') {
      try {
        if (!deviceData || deviceData === '') {
          dataCollectorInstance(clientToken).then()
        }
      } catch (e) {}
    }
  }, [clientToken])

  useEffect(() => {
    if (status === SessionStatusEnum.AUTHENTICATED) {
      const stripePromise = loadStripe(
        process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY!,
      )

      stripePromise.then((stripe) => {
        stripe?.createRadarSession().then((result) => {
          if (result.radarSession?.id) {
            setStripeRadarSession(result.radarSession?.id)
          }
        })
      })
    }
  }, [status])

  const dataCollectorInstance = async (clientToken: string) => {
    const clientInstance = await client.create({
      authorization: clientToken,
    })

    const dataCollectorInstance = await dataCollector.create({
      client: clientInstance,
    })

    setDeviceData(dataCollectorInstance.deviceData)

    return dataCollectorInstance
  }
}
